import type { DemandeProformaDTO } from '@/features/api/extranet/dto/Demande/PROFORMA'
import { PropertyStatus, type PropertyStatusConfiguration } from '@/features/domaine/property-status'
import type { ContextReglesProforma } from '@/features/domaine/regles-akto/PROFORMA/types.ts'

export const propertyStatusConfiguration: PropertyStatusConfiguration<DemandeProformaDTO, ContextReglesProforma> = {
  niveauPermission: PropertyStatus.NotPresent,
  acceptationCg: PropertyStatus.Required,
  attestationSurHonneur: PropertyStatus.Required,
  consentementTraitementDonnees: PropertyStatus.Required,
  lieuSignature: PropertyStatus.Required,
  rib: {
    $model: PropertyStatus.Required,
  },
  remboursements: {
    $model: PropertyStatus.Required,
  },
  referenceExterne: PropertyStatus.Required,
}
